import React from 'react';
import { DropsContextProvider } from '../Drops/DropsContext';
import { DROP } from '../common';
import { PlayerContextProvider } from '../Player/PlayerContext';
import HomePage from './HomePage';

interface GenesisHomeProps {}

const GenesisHome: React.FC<GenesisHomeProps> = () => {
  return (
    <DropsContextProvider drop={DROP.genesis}>
      <PlayerContextProvider>
        <HomePage />
      </PlayerContextProvider>
    </DropsContextProvider>
  );
};

export default GenesisHome;